export const FOOTERLINKS_CMS_DATA = 'FOOTERLINKS_CMS_DATA';
